import { POPOVER } from 'app/shared/components/popover/popover.constants';
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
@Component({
    selector: 'kh-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PopoverComponent {
  @Input() public canClose = false;
  @Input() public hasAction = false;
  @Input() public headerBg = POPOVER.DEFAULT_HEADER_BACKGROUND_COLOR;
  @Input() public bodyBg = POPOVER.DEFAULT_BACKGROUND_COLOR;
  @Input() public iconColor = POPOVER.DEFAULT_ICON_COLOR;
  @Input() public whiteIcon = false;
  @Output() public close = new EventEmitter<number>();
  @Output() public clickOverPopover = new EventEmitter<number>();

  @ContentChild('khPopoverHeader') public khPopoverHeader?: TemplateRef<unknown>;

  public closePopover(): void {
    this.close.emit();
  }

  public clickPopover(): void {
    this.clickOverPopover.emit();
  }
}
